

class IdentityVerificationDTO {
  constructor(identityData) {
    console.log("ESIGNET STAFF - IdentityVerificationDTO: Transforming identity data", identityData);
    const { data, photo, transactionId, signature } = identityData;
    this.transactionId = transactionId;
    this.signature = signature;
    this.regId = data?.identity?.regId;

    this.fullName = {
      eng: data?.identity?.fullName?.find((lang) => lang.language === "eng")?.value,
      amh: data?.identity?.fullName?.find((lang) => lang.language === "amh")?.value,
    };
    this.gender = {
      eng: data?.identity?.gender?.find((lang) => lang.language === "eng")?.value,
      amh: data?.identity?.gender?.find((lang) => lang.language === "amh")?.value,
    };
    this.woreda = {
      eng: data?.identity?.woreda?.find((lang) => lang.language === "eng")?.value,
      amh: data?.identity?.woreda?.find((lang) => lang.language === "amh")?.value,
    };
    this.zone = {
      eng: data?.identity?.zone?.find((lang) => lang.language === "eng")?.value,
      amh: data?.identity?.zone?.find((lang) => lang.language === "amh")?.value,
    };
    this.region = {
      eng: data?.identity?.region?.find((lang) => lang.language === "eng")?.value,
      amh: data?.identity?.region?.find((lang) => lang.language === "amh")?.value,
    };
    this.residenceStatus = {
      eng: data?.identity?.residenceStatus?.find((lang) => lang?.language === "eng")?.value || null,
      amh: data?.identity?.residenceStatus?.find((lang) => lang?.language === "amh")?.value || null,
    };

    this.dateOfBirth = data?.identity?.dateOfBirth;
    this.phone = data?.identity?.phone;
    this.email = data?.identity?.email;
    this.uin = data?.identity?.UIN;

    this.proofOfAddress = data?.identity?.proofOfAddress;
    this.individualBiometrics = data?.identity?.individualBiometrics;
    this.proofOfIdentity = data?.identity?.proofOfIdentity;
    this.idschemaVersion = data?.identity?.IDSchemaVersion;

    this.documents = data?.documents;
    this.photo = photo;
  }

  // Factory method to return a plain object representation
  static toPlainObject(dto) {
    return {
      transactionId: dto.transactionId,
      signature: dto.signature,
      regId: dto.regId,
      fullName: dto.fullName,
      gender: dto.gender,
      woreda: dto.woreda,
      zone: dto.zone,
      region: dto.region,
      residenceStatus: dto.residenceStatus,
      dateOfBirth: dto.dateOfBirth,
      phone: dto.phone,
      email: dto.email,
      uin: dto.uin,
      proofOfAddress: dto.proofOfAddress,
      individualBiometrics: dto.individualBiometrics,
      proofOfIdentity: dto.proofOfIdentity,
      idschemaVersion: dto.idschemaVersion,
      documents: dto.documents,
      photo: dto.photo,
    };
  }
}

export default IdentityVerificationDTO;